<template>
    <div>
        <div class="is-clearfix has-background-white columns plisttable">
            <template v-if="!loading">
                <div class="column"></div>
                <div class="column is-three-quarters  box has-text-centered" style="margin-top: 20px;">
                    <div class="is-size-4 has-text-weight-semibold">找回报名序号</div>
                    <div class="container" style="text-align: left;margin-top: 20px;">
                        <div class="notification">
                            <div style="padding-bottom: 10px;">如果您遗忘了报名序号，可以通过此处正确填写您的身份证号码，以便获取您的报名序号。</div>
                            <!-- <div style="padding-bottom: 10px;">
                                请使用本人实名认证过的账号通过微信或支付宝支付
                                <strong>1元</strong>
                                。
                            </div> -->
                            <div>报名序号会通过手机短信下发至您预留的手机号码中，请注意查收。</div>
                        </div>
                    </div>
                    <div class="field" style="margin-top: 50px; margin-bottom: 50px" v-if="plans">
                        <div class="control" style="width: 50%; margin:0 auto;">
                            <mu-select label="请选择报名计划：" v-model="pid" full-width>
                                <mu-option v-for="option in plans" :key="option.id" :label="option.name" :value="option.id"></mu-option>
                            </mu-select>
                        </div>
                        <div class="control" style="width: 50%; margin:0 auto;">
                            <input class="input is-info is-medium" type="text" placeholder="请输入您要找回的报名序号登记的身份证号码" v-model="idno" />
                        </div>
                        <div style="padding-top:20px; margin: 0 auto;">
                            <button class="button is-primary" v-on:click="doCheckidno">找回报名序号</button>
                            <div class="buttons  is-centered" style="margin-top:20px;">
                                请妥善保管您的报名序号，如遗忘，可通过本页面找回
                                <span style="color: red; font-weight: bold;">（同一报名计划仅支持一次找回）</span>
                                。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column"></div>
            </template>
        </div>
        <mu-dialog title="找回报名序号" width="400" :open.sync="dialogVisible" :esc-press-close="false" :overlay-close="false">
            <div style="text-align: center;">
                <img style="margin: 0px auto; width: 300px; height: 300px;" :src="pay.qr" />

                <p style="margin-top: 10px;">
                    请打开
                    <span class="has-text-danger is-size-5 has-text-weight-semibold	">[ {{ pay.cnl }} ]</span>
                    支付
                    <span class="has-text-danger is-size-5 has-text-weight-semibold	">[ 1 ]</span>
                    元
                </p>
                <p style="margin-top: 10px;">[ {{ pay.id }} ]</p>
            </div>
            <mu-button slot="actions" flat color="warning" @click="doPayCancel">取消支付</mu-button>
            <mu-button slot="actions" flat color="primary" @click="doPayFinish">支付成功</mu-button>
        </mu-dialog>
    </div>
</template>

<script>
export default {
    name: 'getBMXH',
    data() {
        return {
            plans: [],
            options: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6', 'Option 7', 'Option 8', 'Option 9', 'Option 10'],
            error: false,
            loading: true,
            // sno: '',
            idno: '',
            pid: '',
            result: {
                post: {}
            },
            dialogVisible: false,
            payshou: false,
            pay: {}
        }
    },
    mounted() {
        this.init()

        // 2022年12月8日
        // 因疫情特殊情况，这里暂时改为手动返回，暂不通过接口
        // this.$http
        //     .get('/comm/data/plan/running', {
        //         params: {
        //             _: new Date().getTime()
        //         }
        //     })
        //     .then(result => {
        //         this.plans = result.datas
        //         this.loading = false
        //         this.plans.forEach(plan => {
        //             sessionStorage.setItem('Plan_' + plan.id, JSON.stringify(plan))
        //         })
        //     })
        // 因疫情特殊情况，这里暂时改为手动返回，暂不通过接口
        this.plans = [{ name: '台前县2024年教育系统和县委党校公开招聘工作人员公告', id: 'UTJPPKDB' }]
    },
    methods: {
        init() {
            this.doLoad()
        },
        alert(info) {
            this.$message({
                title: '提示',
                content: info,
                mode: 'alert'
            })
        },
        doLoad() {
            // this.$http
            //     .get('/app/rec/reg/state', {
            //         params: {
            //             _: new Date().getTime(),
            //             idno: this.$route.query.idno,
            //             sno: this.$route.query.sno
            //         }
            //     })
            //     .then(result => {
            //         this.result = result.data
            //         this.loading = false
            //     })
            this.loading = false
        },
        doCheckidno() {
            if (!this.pid) {
                this.alert('请先选择报名计划')
                this.payshou = false
                return
            }
            if (!this.idno) {
                this.alert('请填写15位或18位身份证号')
                this.payshou = false
                return
            }
            if (!/^(^\d{15}$)|(^\d{17}([0-9]|X)$)$/.test(this.idno)) {
                this.alert('身份证号有误，请重填')
                this.payshou = false
                return
            }
            this.$http
                .post('/app/rec/sno/forget', {
                    idno: this.idno,
                    // cnl: 'Aliqr',
                    pid: this.pid
                })
                .then(result => {
                    if (result.code === 0) {
                        this.alert('报名序号已发送至您的手机，请注意查收')
                        this.doLoad()
                    }
                })
            // this.payshou = true
            // this.dialogVisible = true
            // 接口地址 /app/rec/pay/forget
        },
        // doAlipay() {
        //     this.pay = {}
        //     if (!this.idno || !this.pid) {
        //         return
        //     }
        //     this.$http
        //         .post('/app/rec/pay/forget', {
        //             idno: this.idno,
        //             cnl: 'Aliqr',
        //             pid: this.pid
        //         })
        //         .then(result => {
        //             if (result.code === 0) {
        //                 this.pay = result.data
        //                 this.pay.cnl = '支付宝'
        //                 this.dialogVisible = true
        //             }
        //         })
        // },
        // doWxpay() {
        //     this.pay = {}
        //     if (!this.idno) {
        //         return
        //     }
        //     this.$http
        //         .post('/app/rec/pay/forget', {
        //             idno: this.idno,
        //             cnl: 'Wxqr',
        //             pid: this.pid
        //         })
        //         .then(result => {
        //             if (result.code === 0) {
        //                 this.pay = result.data
        //                 this.pay.cnl = '微信'
        //                 this.dialogVisible = true
        //             }
        //         })
        // },
        // doPayFinish() {
        //     if (!this.pay.id) {
        //         return
        //     }
        //     this.$http
        //         .get('/app/rec/pay/state', {
        //             params: {
        //                 _: new Date().getTime(),
        //                 id: this.pay.id
        //             }
        //         })
        //         .then(result => {
        //             if (result.code == 0) {
        //                 if (result.data.st === 'Success') {
        //                     this.alert('报名序号已发送至您的手机，请注意查收')
        //                     this.doLoad()
        //                     this.dialogVisible = false
        //                 } else if (result.data.st === 'Wait') {
        //                     this.alert('尚未完成支付')
        //                 } else {
        //                     this.alert('支付未成功，请重新支付')
        //                     this.dialogVisible = false
        //                 }
        //             }
        //         })
        // },
        // doPayCancel() {
        //     if (!this.pay.id) {
        //         return
        //     }
        //     this.$http
        //         .post('/app/rec/pay/cancel', {
        //             id: this.pay.id
        //         })
        //         .then(result => {
        //             if (result.code === 0) {
        //                 this.pay = {}
        //                 this.dialogVisible = false
        //             }
        //         })
        // },
        doPrintRegt() {
            if (!this.result.id) {
                return
            }
            this.$http
                .get('/app/rec/reg/table', {
                    params: {
                        _: new Date().getTime(),
                        id: this.result.id
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        let win = window.open()
                        win.document.write(result.data.info)
                        win.document.close()
                        win.focus()
                    }
                })
        },
        doPrintZkzt() {
            if (!this.result.id) {
                return
            }
            this.$http
                .get('/app/rec/reg/zkz', {
                    params: {
                        _: new Date().getTime(),
                        id: this.result.id
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        let win = window.open()
                        win.document.write(result.data.info)
                        win.document.close()
                        win.focus()
                    }
                })
        }
    }
}
</script>

<style scoped>
td {
    vertical-align: middle !important;
    text-align: center !important;
}
th {
    vertical-align: middle !important;
    text-align: center !important;
}
</style>
